import type { Dictionary } from './en';

/** French (Français). ⚠️ Not natively reviewed — see i18n/index.tsx. */
export const fr: Dictionary = {
    'nav.find': 'Trouver',
    'nav.prayer': 'Prière',
    'nav.cards': 'Cartes',
    'nav.saved': 'Favoris',
    'nav.main': 'Navigation principale',
    'nav.skip': 'Aller au contenu',

    'search.placeholder': 'Rechercher à {city}',
    'search.label': 'Rechercher des lieux à {city}',
    'search.clear': 'Effacer la recherche',
    'search.matches': '{count} résultats',
    'search.matches_one': '{count} résultat',
    'city.choose': 'Choisir une ville',
    'city.trust.certified': 'Certifiée',
    'city.trust.mixed': 'En partie certifiée',
    'city.trust.community': 'Communautaire',

    'filter.label': 'Filtrer les résultats',
    'filter.eat': 'Manger',
    'filter.shop': 'Acheter',
    'filter.pray': 'Prier',
    'filter.certifiedOnly': 'Certifiés seulement',
    'filter.hideExpired': 'Masquer les expirés',
    'filter.nearMe': 'À moins de 2 km',
    'filter.clear': 'Effacer',
    'filter.noneCertified': 'Aucun établissement certifié dans cette ville',
    'filter.noneExpired': 'Aucun certificat expiré ici',

    'results.count': '{count} lieux',
    'results.count_one': '{count} lieu',
    'results.nearestFirst': ', les plus proches d’abord',
    'results.loading': 'Chargement de {city}…',
    'results.error': 'Impossible de charger {city}. Vérifiez votre connexion et réessayez.',
    'results.emptyTitle': 'Aucun résultat pour ces filtres.',
    'results.emptyBody': 'Essayez de retirer un filtre, ou cherchez un autre nom ou quartier.',
    'results.clearAll': 'Effacer tous les filtres',
    'results.heading': 'Lieux halal à {city}',

    'banner.community': 'Non certifiés.',
    'banner.communityBody':
        'Ces {count} établissements proviennent de {source}. Aucun organisme de certification halal ne les a vérifiés — demandez au personnel avant de commander.',
    'banner.certified': '{certified} sur {total} détiennent un certificat en cours de validité',
    'banner.certifiedBody': ' délivré par {source}.',
    'banner.lapsed': ' {count} a expiré et est signalé comme tel.',
    'banner.lapsed_other': ' {count} ont expiré et sont signalés comme tels.',
    'banner.mixedTail': ' Les autres sont des signalements communautaires, non certifiés.',
    'banner.checked': 'Vérifié auprès de {source} {when}.',

    'assurance.certified': 'Certifié halal',
    'assurance.certified.short': 'Certifié',
    'assurance.certified.detail': 'L’établissement détient un certificat halal délivré par un organisme reconnu.',
    'assurance.certified_kitchen': 'Cuisine halal certifiée',
    'assurance.certified_kitchen.short': 'Cuisine certifiée',
    'assurance.certified_kitchen.detail': 'Une cuisine halal certifiée et dédiée, au sein d’un établissement qui sert aussi du non-halal.',
    'assurance.muslim_friendly': 'Adapté aux musulmans',
    'assurance.muslim_friendly.short': 'Adapté',
    'assurance.muslim_friendly.detail': 'Certifié sans porc ni alcool, mais l’établissement n’est pas entièrement halal.',
    'assurance.muslim_owned': 'Tenu par des musulmans',
    'assurance.muslim_owned.short': 'Tenu par des musulmans',
    'assurance.muslim_owned.detail': 'Tenu par des musulmans, sans certificat délivré par un tiers.',
    'assurance.self_declared': 'Halal auto-déclaré',
    'assurance.self_declared.short': 'Auto-déclaré',
    'assurance.self_declared.detail': 'L’établissement se déclare halal. Aucun organisme ne l’a vérifié.',
    'assurance.community_reported': 'Signalé par la communauté',
    'assurance.community_reported.short': 'Communauté',
    'assurance.community_reported.detail':
        'Cartographié par les contributeurs d’OpenStreetMap. Aucun organisme ne l’a certifié — demandez au personnel avant de commander.',

    'cert.label': 'Certificat halal',
    'cert.current': 'Certificat valide',
    'cert.expiring_soon': 'Expire bientôt',
    'cert.expired': 'Certificat expiré',
    'cert.renewal_pending': 'Renouvellement en cours',
    'cert.listed': 'Inscrit comme certifié',
    'cert.delisted': 'Retiré du registre',
    'cert.unknown': 'Statut inconnu',
    'cert.reference': 'Référence',
    'cert.category': 'Catégorie',
    'cert.validUntil': 'Valide jusqu’au',
    'cert.expiredOn': 'Expiré le',
    'cert.confirmed': 'Confirmé',
    'cert.noEndDate': 'aucune date de fin publiée',
    'cert.noCertifier': 'Organisme non renseigné',
    'cert.expiredNote': 'Ce certificat a expiré. Il a peut-être été renouvelé depuis — demandez à l’établissement avant de commander.',
    'cert.delistedNote': 'Cet établissement ne figure plus au registre de {certifier}. Considérez-le comme non certifié.',
    'cert.pendingNote': 'Le registre indique que ce certificat est en cours de renouvellement.',
    'cert.openEndedNote':
        'Cet organisme ne publie pas de date d’expiration. Un établissement reste au registre jusqu’au retrait de son certificat.',
    'cert.ariaValid': 'Valide jusqu’au {date}',
    'cert.ariaExpired': 'Expiré le {date}',
    'cert.ariaOpen': 'Aucune date d’expiration publiée. Confirmé {when}.',

    'place.back': 'Retour à la liste',
    'place.save': 'Enregistrer',
    'place.saved': 'Enregistré',
    'place.address': 'Adresse',
    'place.hours': 'Horaires',
    'place.phone': 'Téléphone',
    'place.directions': 'Itinéraire',
    'place.website': 'Site web',
    'place.share': 'Partager',
    'place.listedBy': 'Référencé par {source}',
    'place.checkedWhen': 'Certificat vérifié {when}',
    'place.approximate': 'Emplacement approximatif — placé sur {district}, l’adresse n’ayant pas pu être rattachée à un bâtiment.',
    'place.theDistrict': 'le quartier',
    'place.away': 'à {distance}',

    'type.restaurant': 'Restaurant',
    'type.cafe': 'Café',
    'type.bakery': 'Boulangerie',
    'type.fast_food': 'Restauration rapide',
    'type.food_court': 'Aire de restauration',
    'type.hotel_restaurant': 'Restaurant d’hôtel',
    'type.grocery': 'Épicerie',
    'type.butcher': 'Boucherie',
    'type.mosque': 'Mosquée',
    'type.prayer_room': 'Salle de prière',
    'type.attraction_dining': 'Restauration de site touristique',

    'prayer.title': 'Prière',
    'prayer.needLocation': 'Autorisez l’accès à votre position pour obtenir les horaires de prière et la direction de la qibla.',
    'prayer.next': 'Prochaine',
    'prayer.fajr': 'Fajr',
    'prayer.sunrise': 'Lever du soleil',
    'prayer.dhuhr': 'Dhuhr',
    'prayer.asr': 'Asr',
    'prayer.maghrib': 'Maghrib',
    'prayer.isha': 'Isha',
    'prayer.inHours': 'dans {hours} h {minutes} min',
    'prayer.inMinutes': 'dans {minutes} min',
    'prayer.imminent': 'dans moins d’une minute',
    'prayer.highLatitude':
        'À cette latitude, le soleil ne descend pas assez sous l’horizon aujourd’hui pour calculer le Fajr et l’Isha de façon conventionnelle. Suivez les horaires de votre mosquée.',
    'prayer.method': 'Méthode de calcul',
    'prayer.methodLabel': 'Méthode',
    'prayer.asrLabel': 'Asr',
    'prayer.asrStandard': 'Standard (Chafiite, Malikite, Hanbalite)',
    'prayer.asrHanafi': 'Hanafite',
    'prayer.calcNote':
        'Calculé sur votre appareil à partir de votre position, donc hors ligne. Ces horaires sont indicatifs — suivez votre mosquée en cas d’écart.',

    'qibla.title': 'Qibla',
    'qibla.fromNorth': 'depuis le nord',
    'qibla.aria': 'La qibla est à {degrees} degrés du nord géographique',
    'qibla.needsPermission': 'Cet appareil a besoin d’une autorisation pour servir de boussole.',
    'qibla.usecompass': 'Utiliser la boussole',
    'qibla.noCompass': 'Aucune lecture de boussole ici. Orientez-vous à {degrees}° du nord géographique avec une boussole.',

    'cards.title': 'Montrez ceci au personnel',
    'cards.type': 'Type de carte',
    'cards.language': 'Langue',
    'cards.halal': 'Halal',
    'cards.vegetarian': 'Végétarien',
    'cards.allergies': 'Allergies',
    'cards.hint': 'Augmentez la luminosité et tendez le téléphone.',

    'saved.title': 'Favoris',
    'saved.emptyTitle': 'Rien d’enregistré pour l’instant.',
    'saved.emptyBody': 'Touchez le signet sur un lieu pour le garder ici — il reste accessible hors ligne.',
    'saved.emptyCta': 'Trouver où manger',
    'saved.staleOne': '{count} lieu enregistré a un certificat qui n’est plus valide.',
    'saved.staleOther': '{count} lieux enregistrés ont un certificat qui n’est plus valide.',
    'saved.staleBody': ' Les certificats expirent après l’enregistrement — vérifiez avant de vous déplacer.',
    'saved.remove': 'Retirer {name} des favoris',

    'lang.choose': 'Choisir une langue',
    'lang.label': 'Langue',

    'time.today': 'aujourd’hui',
    'time.yesterday': 'hier',
    'time.daysAgo': 'il y a {count} jours',
    'time.on': 'le {date}',
};
